import { ReportCommonReduxTypes, ReportListActionDispatch } from "./types";

export const listReports = (payload: any): ReportListActionDispatch => ({
  type: ReportCommonReduxTypes.LIST_REPORT,
  payload: payload
});

export const resetReport = (): ReportListActionDispatch => ({
  type: ReportCommonReduxTypes.RESET,
  payload: {}
});

export const downloadReport = (payload: any): ReportListActionDispatch => ({
  type: ReportCommonReduxTypes.DOWNLOAD_REPORT,
  payload: payload
});